export type SkillTier = 'Expert' | 'Proficient' | 'Familiar';

export interface SkillItem {
    name: string;
    // Retained as the source of truth; the tier below is derived from it.
    level: number;
    // devicon class, e.g. "devicon-typescript-plain colored". Omit for a text-only pill.
    icon?: string;
}

// Order within a tier is preserved from this list.
const skillsConfig: SkillItem[] = [
    { name: 'C#', level: 95, icon: 'devicon-csharp-plain colored' },
    { name: 'TypeScript', level: 95, icon: 'devicon-typescript-plain colored' },
    { name: 'JavaScript', level: 95, icon: 'devicon-javascript-plain colored' },
    { name: '.NET', level: 95, icon: 'devicon-dotnetcore-plain colored' },
    { name: 'SQL', level: 90, icon: 'devicon-microsoftsqlserver-plain colored' },
    { name: 'Git', level: 90, icon: 'devicon-git-plain colored' },
    { name: 'HTML', level: 90, icon: 'devicon-html5-plain colored' },
    { name: 'SCSS', level: 88, icon: 'devicon-sass-original colored' },
    { name: 'Entity Framework', level: 88 },
    { name: 'Blazor', level: 80, icon: 'devicon-blazor-plain colored' },
    { name: 'PowerShell', level: 80, icon: 'devicon-powershell-plain colored' },
    { name: 'Azure DevOps', level: 78, icon: 'devicon-azuredevops-plain colored' },
    { name: 'Angular', level: 75, icon: 'devicon-angular-plain colored' },
    { name: 'Azure', level: 70, icon: 'devicon-azure-plain colored' },
    { name: 'Terraform', level: 68, icon: 'devicon-terraform-plain colored' },
    { name: 'Python', level: 55, icon: 'devicon-python-plain colored' },
    { name: 'Java', level: 50, icon: 'devicon-java-plain colored' },
];

export const tierForLevel = (level: number): SkillTier => {
    if (level >= 85) return 'Expert';
    if (level >= 60) return 'Proficient';
    return 'Familiar';
};

// Tiers in display order.
export const SKILL_TIERS: SkillTier[] = ['Expert', 'Proficient', 'Familiar'];

export default skillsConfig;
